<template>
  <div class="height-100-p">
    <el-table :data="appointments.list" v-loading="appointments.listLoading" id="appointment-data-list"
      ref="summaryList" size="mini" tooltip-effect="dark" sortable class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')" :default-sort="{ prop: 'shipDate', order: 'descending' }"
      @sort-change="handleSortChange" stripe>
      <el-table-column :label="$t('customerCenter.appointments.loadNumber')" min-width="120" prop="loadNumber"
        sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.loadNumber }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('customerCenter.appointments.shipDate')" min-width="90" prop="shipDate"
        sortable="custom">
        <template slot-scope="scope">
          <span>{{ formatDate(scope.row.shipDate) }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('customerCenter.appointments.account')" min-width="150" prop="accountName"
        sortable="custom">
        <template slot-scope="scope">
          {{ `${scope.row.accountName} - ${scope.row.accountNumber}` }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('customerCenter.appointments.appointmentDate')" min-width="120"
        prop="appointmentStartDate" sortable="custom">
        <template slot-scope="scope">
          <span v-if="scope.row.fcfs">
            {{ formatDate(scope.row.appointmentStartDate) }}
            <template v-if="scope.row.appointmentEndDate">
              / {{ formatDate(scope.row.appointmentEndDate) }}
            </template>
          </span>
          <span v-else-if="scope.row.appointmentStartDate">
            {{ formatDate(scope.row.appointmentStartDate) }}
          </span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('customerCenter.appointments.appointmentTime')" min-width="120"
        prop="appointmentStartTime" sortable="custom">
        <template slot-scope="scope">
          <span v-if="scope.row.fcfs">
            {{ scope.row.appointmentStartTime }}
            <template v-if="scope.row.appointmentEndTime">
              / {{ scope.row.appointmentEndTime }}
            </template>
          </span>
          <span v-else-if="scope.row.appointmentStartTime">
            {{ scope.row.appointmentStartTime }}
          </span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('customerCenter.appointments.note')" min-width="200" prop="note">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" v-if="scope.row.note && scope.row.note.length > 20">
            <p>{{ scope.row.note }}</p>
            <div slot="reference" class="name-wrapper">
              {{ scope.row.note.substring(0, 20) }}...
            </div>
          </el-popover>
          <span v-else>{{ scope.row.note }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('customerCenter.appointments.sent')" width="60" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.sent === true" class="el-icon-success green-success" style="font-size: 1.2rem;"></i>
          <i v-else-if="scope.row.sent === false" class="el-icon-error" style="color: red; font-size: 1.2rem;"></i>
          <i v-else class="el-icon-question" style="color: gray; font-size: 1.2rem;"></i>
        </template>
      </el-table-column>

      <el-table-column :label="$t('customerCenter.appointments.hub')" width="60" prop="hub" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.hub }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('customerCenter.appointments.actions')" align="center" width="100"
        class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.details')"
            placement="top-start">
            <detail-appointments :appointment="scope.row" />
          </el-tooltip>

          <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.edit')" placement="top-start">
            <add-appointment :appointment="scope.row" @appointment-saved="handleAppointmentSaved" />
          </el-tooltip>

          <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('customerCenter.appointments.sendMessage')"
            placement="top-start">
            <i class="el-icon-s-promotion icon-action" @click="handleSendMessage(scope.row.id)"></i>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.delete')"
            placement="top-start">
            <i class="el-icon-delete icon-action" @click="handleDelete(scope.row)"></i>
          </el-tooltip>
        </template>

      </el-table-column>
    </el-table>

    <div class="pagination-footer" v-show="appointments.total > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('customerCenter.appointments.totalLabel') }}</span>
        {{ appointments.total }}
      </span>
      <el-pagination @size-change="handleSizeChange" :page-sizes="sizes" :page-size="appointments.listQuery.limit"
        :current-page="appointments.listQuery.page" @current-change="handleCurrentChange" :total="appointments.total"
        layout="sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';
import { APPOINTMENTS_SEARCH, APPOINTMENTS_DELETE } from '@/store/actions';
import constants from '../../../utils/constants';
import AddAppointment from './components/addAppointment/AddAppointment';
import DetailAppointments from './components/detailAppointments/DetailAppointments';

export default {
  name: 'SearchSummaryAppointments',
  components: {
    AddAppointment,
    DetailAppointments
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES
    };
  },
  computed: {
    ...mapGetters([
      'appointments'
    ])
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const m = moment(date);
      if (!m.isValid()) return '';
      return m.format('MM/DD/YYYY');
    },
    handleSizeChange(val) {
      const query = { ...this.appointments.listQuery, limit: val };
      this.$store.dispatch('appointments/setListQuery', query);
    },
    handleCurrentChange(val) {
      const query = { ...this.appointments.listQuery, page: val };
      this.$store.dispatch('appointments/setListQuery', query);
    },
    async handleDelete(row) {
      Message.closeAll();

      const confirm = await this.$confirm(
        this.$t('customerCenter.appointments.deleteAppointmentConfirmation'),
        { confirmButtonText: this.$t('common.delete'), dangerouslyUseHTMLString: true }
      ).catch(() => {
      });

      if (confirm) {
        const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
        try {
          const response = await this.$store.dispatch(APPOINTMENTS_DELETE, row.id);
          this.$message.success(response.message);
        } finally {
          loading.close();
          await this.$store.dispatch(APPOINTMENTS_SEARCH);
        }
      }
    },
    handleSortChange({ prop, order }) {
      const query = { ...this.appointments.listQuery, sortProp: prop, sortOrder: order };
      this.$store.dispatch('appointments/setListQuery', query);
    },
    handleAppointmentSaved(savedAppointment) {
      const index = this.appointments.list.findIndex(appointment => appointment.id === savedAppointment.id);
      if (index !== -1) {
        this.$set(this.appointments.list, index, { ...this.appointments.list[index], ...savedAppointment });
      }
    },
    handleSendMessage(appointmentId) {
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store.dispatch('appointments/sendMessage', appointmentId)
        .then((response) => {
          this.$message.success(response.message);
          this.$store.dispatch(APPOINTMENTS_SEARCH);
        })
        .catch(() => {
          this.$message.error(this.$t('customerCenter.appointments.sendMessageError'));
        })
        .finally(() => {
          loading.close();
        });
    },
    handleSendMessageBulk(appointmentIds) {
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store.dispatch('appointments/sendMessageBulk', { appointmentIds })
        .then((response) => {
          this.$message.success(response.message);
          this.$store.dispatch(APPOINTMENTS_SEARCH);
        })
        .catch(() => {
          this.$message.error(this.$t('customerCenter.appointments.sendMessageError'));
        })
        .finally(() => {
          loading.close();
        });
    }
  },

};

</script>
